import type { FluidOwaSource } from '../enums/FluidEnums';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isCollabSpaceReadEnabled } from './isCollabSpaceReadEnabled';
import type { MailboxInfo } from 'owa-client-types';
import { isEduConsolidated } from './isEduConsolidated';

export function isCollabSpaceEnabledForSource(
    fluidOwaSource: FluidOwaSource,
    mailboxInfo: MailboxInfo
): boolean {
    if (!isFeatureEnabled('cal-cmp-fluidCollaborativeSpaceEdu') && isEduConsolidated(mailboxInfo)) {
        return false;
    }
    switch (fluidOwaSource) {
        case 'CalendarReadingPane':
        case 'MailCalendarCard':
            return isCollabSpaceReadEnabled();
        case 'CalendarCompose':
            return (
                // Functionality restricted to Teams client as per EU settlement
                // cal-disable-meeting-notes will be rolled out to "true" for everything except Teams
                !isFeatureEnabled('cal-disable-meeting-notes') &&
                isFeatureEnabled('cmp-prague') &&
                isFeatureEnabled('cal-cmp-fluidCollaborativeSpace')
            );
        default:
            return false;
    }
}
